export default "__VITE_ASSET__Bs1VQ75T__"